import { buildApi } from '../http-client/http-client';
import withAuth from '../auth-service/with-auth';
import { hasValue } from '../../utils/common-utils';
import * as Models from '../../models';
import { TsFixMeType } from '../../types';
import { getExams, getExam, getAlleged, getChallenges, ChallengesResponse, getExamsStats } from './functions';
//FIXME replace endpoints to go to production cache, as preprod is not working
/**
 * @deprecated
 */
const fixImage = (image: TsFixMeType) => {
  if (!hasValue(image)) {
    return {};
  }
  const newImage = { ...image };
  Object.keys(newImage).forEach(key => {
    newImage[key] = image[key].replace('preprod666-api', 'www').replace('preprod666', 'www');
  });
  return { image: newImage };
};

/**
 * @deprecated
 */
const questionMapper = (question: TsFixMeType, index: number) => ({
  ...question,
  ...fixImage(question.image),
  index,
  answers: question.answers.map((answer: TsFixMeType) => ({
    ...answer,
    ...fixImage(answer.image),
  })),
});

/**
 * @deprecated not used anymore
 */
export const getUserStats = withAuth(async (token: string, userId: number, realizedExamId: number) =>
  buildApi(token).get(`${process.env.API_BASE_URL}/api/v1/users/${userId}/exams/realized/${realizedExamId}/statistics`),
);

/**
 * @deprecated not used anymore
 */
export const getAllStats = withAuth(async (token: string, examId: number) =>
  buildApi(token).get(`${process.env.API_BASE_URL}/api/v1/stats/exam/${examId}`),
);

/**
 * @deprecated Use getTestById function from v2.0 instead
 */
export const getRealizedExamDetails = withAuth(async (token: string, userId: number, testId: number) => {
  const realizedExam = await buildApi(token).get(
    `${process.env.API_BASE_URL}/api/v1/users/${userId}/exams/realized/${testId}`,
  );

  if (realizedExam?.exam?.questions) {
    return {
      ...realizedExam,
      exam: {
        ...realizedExam.exam,
        questions: realizedExam.exam.questions.map(questionMapper),
      },
    };
  }
  return realizedExam;
});

interface GetExamTypeResponse {
  resources: {
    type: Models.ExamType;
    enabled: boolean;
    examCount: number | null;
  }[];
}
export const getExamTypesByOpposition = withAuth<GetExamTypeResponse, [Models.OppositionId]>(
  async (token: string, oppositionId: Models.OppositionId) =>
    buildApi(token).get(`${process.env.API_BASE_URL}/api/v2.0/exam-types?filters[opposition]=${oppositionId}`),
);

/**
 * @deprecated use getExamTypesByOpposition instead
 */
export const getExamTypes = async (oppositionId: Models.OppositionId) => getExamTypesByOpposition(oppositionId);

/**
 * @deprecated
 **/
export const createRandomExam = withAuth(async (token: string, oppositionId: Models.OppositionId, body: any) =>
  buildApi(token).post(`${process.env.API_BASE_URL}/api/v1.1/exams/oficial/${oppositionId}`, body, true),
);

/**
 * @deprecated
 **/
export const createCustomExam = withAuth(async (token: string, oppositionId: Models.OppositionId, body: any) =>
  buildApi(token).post(`${process.env.API_BASE_URL}/api/v1.1/exams/custom/${oppositionId}`, body, true),
);

/**
 * @deprecated
 **/
export const createMostFailedExam = withAuth(async (token: string, oppositionId: Models.OppositionId, body: any) =>
  buildApi(token)
    .post(`${process.env.API_BASE_URL}/api/v1.1/exams/mostfailed/${oppositionId}`, body, true)
    .then(response => {
      // PATCH: waiting for https://kanbanflow.com/t/7tKLjCoV
      if (response.status === 204) {
        return Promise.reject({ error: { code: response.status } });
      }
      return response;
    }),
);

/**
 * @deprecated
 **/
export const createNotAnsweredExam = withAuth(async (token: string, oppositionId: Models.OppositionId, body: any) =>
  buildApi(token)
    .post(`${process.env.API_BASE_URL}/api/v1.1/exams/notanswered/${oppositionId}`, body, true)
    .then(response => {
      // PATCH: waiting for https://kanbanflow.com/t/7tKLjCoV
      if (response.status === 204) {
        return Promise.reject({ error: { code: response.status } });
      }
      return response;
    }),
);

/**
 * @deprecated use getExamById instead
 */
export const takeChallenge = withAuth(async (token: string, challengeToken: string, challengeTitle: string) =>
  buildApi(token)
    .post(`${process.env.API_BASE_URL}/api/v1/retos/${challengeToken}/participar`, {}, true)
    .then(exam => ({ ...exam, token: challengeToken, challengeTitle })),
);

export type CreateExamArgs = {
  type: Models.ExamType;
  oppositionId: Models.OppositionId;
  contentsRequestedIds?: string[];
  organizationIds?: number[];
  numberOfQuestions?: number;
};

export const createExam = withAuth<{ id: Models.ExamId }, [CreateExamArgs]>(
  async (token, examConfiguration: CreateExamArgs) => {
    return buildApi(token).post(`${process.env.API_BASE_URL}/api/v2.0/exams`, examConfiguration, true);
  },
);

/**
 * @deprecated use v2.0 instead
 */
export const createChallenge = withAuth(
  async (
    token: string,
    {
      oppositionId,
      numQuestions,
      matters,
      topics,
      organizations,
      title,
      description,
      startDate,
      endDate,
      isPublic,
      students,
    }: TsFixMeType,
  ) => {
    return buildApi(token).postFormData(`${process.env.API_BASE_URL}/api/v1/retos/oposicion/${oppositionId}/crear`, {
      type: 'random',
      demo: false,
      title: title,
      numberQuestions: numQuestions,
      'exam_bundle_create_challenge[title]': title,
      'exam_bundle_create_challenge[description]': description,
      'exam_bundle_create_challenge[dateStart]': startDate,
      'exam_bundle_create_challenge[dateFinish]': endDate,
      'exam_bundle_create_challenge[type]': isPublic ? 'public' : 'private',
      'exam_bundle_create_challenge[students][]': students,
      'matter[]': matters,
      'topic[]': topics,
      'organizations[]': organizations,
    });
  },
);

/**
 * @deprecated old v1.1 API, not used anymore
 */
export const createTrialExam = withAuth<TsFixMeType, [Models.OppositionId, any]>(
  async (token: string, oppositionId: Models.OppositionId, body: any) =>
    buildApi(token).post(`${process.env.API_BASE_URL}/api/v1.1/exams/trial/${oppositionId}`, body, true),
);

/**
 * @deprecated There is no service to recover a full exam. Go ahead!
 */
export const getExamById = withAuth<TsFixMeType, [Models.ExamId]>(async (token: string, examId: Models.ExamId) => {
  const exam = await buildApi(token).get(`${process.env.API_BASE_URL}/api/v1/exams/${examId}`);
  return {
    ...exam,
    questions: exam.questions.map(questionMapper),
  };
});

/**
 * @deprecated there's no saved exams anymore, no local storage is needed
 */
export const getSavedExams = async (storage: any, user: TsFixMeType, oppositionId: Models.OppositionId) => {
  let exams: TsFixMeType = [];
  const keys = await storage.getAllKeys();

  for (const key of keys) {
    if (key.startsWith(`${user}-`)) {
      const storedValue = JSON.parse(await storage.getItem(key));
      if (oppositionId && storedValue.opposition.id !== oppositionId) continue;

      exams = [
        ...exams.map((exam: TsFixMeType) => ({
          ...exam,
          questions: exam?.questions?.map((question: TsFixMeType, index: number) => ({
            ...question,
            index,
          })),
        })),
        storedValue,
      ];
    }
  }
  return exams;
};

/**
 * @deprecated is not used anymore and should be removed since we do not support local storage saved exams
 * @param storage
 * @param user
 * @param examId
 */
export const deleteSavedExam = async (storage: any, user: TsFixMeType, examId: number) => {
  storage.removeItem(`${user}-${examId}`);
};

/**
 * @deprecated should be removed, old code
 */
export const isExamSolvedByUser = withAuth(async (token: string, examId: number) =>
  buildApi(token).get(`${process.env.API_BASE_URL}/api/v1/me/exams/${examId}/realized`),
);

export const getChallengesWithAccessWindow = (
  oppositionId?: Models.OppositionId,
  pageSize?: number,
  page?: number,
): Promise<ChallengesResponse> =>
  getChallenges({
    isSimulation: true,
    pageSize: pageSize || 100,
    oppositionId: oppositionId,
    page: page,
  });

export default {
  getUserStats,
  getAllStats,
  getRealizedExamDetails,
  getExamTypesByOpposition,
  getExamTypes,
  getExams,
  getExam,
  getAlleged,
  createChallenge,
  createRandomExam,
  createCustomExam,
  createMostFailedExam,
  createNotAnsweredExam,
  takeChallenge,
  createExam,
  createTrialExam,
  getExamById,
  getSavedExams,
  deleteSavedExam,
  getChallenges,
  isExamSolvedByUser,
  getChallengesWithAccessWindow,
  getExamsStats,
};
